import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICommunicationTemplate } from "../../utils/types/models";

export default createEntityReducer<ICommunicationTemplate>(Endpoint.CommunicationTemplates, Endpoint.CommunicationTemplatesList);
